import { render, staticRenderFns } from "./GoodIssuedPivot.vue?vue&type=template&id=7980dc8d"
import script from "./GoodIssuedPivot.vue?vue&type=script&lang=js"
export * from "./GoodIssuedPivot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports